// import React, { useState, useEffect } from 'react';

// const CodeLaptop3D = () => {
//   const [displayedLines, setDisplayedLines] = useState([]);
//   const [currentLineIndex, setCurrentLineIndex] = useState(0);
//   const [currentCharIndex, setCurrentCharIndex] = useState(0);

//   const codeLines = [
//     { text: 'from camel.agents import ChatAgent', type: 'import' },
//     { text: 'from camel.models import ModelFactory', type: 'import' },
//     { text: 'from camel.types import ModelPlatformType, ModelType', type: 'import' },
//     { text: '', type: 'empty' },
//     { text: '# Initialize AI Agent with different methods', type: 'comment' },
//     { text: 'agent = ChatAgent(', type: 'code' },
//     { text: '    "You are a helpful assistant.",', type: 'string' },
//     { text: '    model="gpt-4o-mini"', type: 'param' },
//     { text: ')', type: 'code' },
//     { text: '', type: 'empty' },
//     { text: '# Using ModelFactory for advanced setup', type: 'comment' },
//     { text: 'model = ModelFactory.create(', type: 'code' },
//     { text: '    model_platform=ModelPlatformType.OPENAI,', type: 'param' },
//     { text: '    model_type=ModelType.GPT_4O_MINI,', type: 'param' },
//     { text: ')', type: 'code' },
//     { text: '', type: 'empty' },
//     { text: 'agent = ChatAgent("Assistant", model=model)', type: 'code' },
//     { text: 'response = agent.step("Hello, AI!")', type: 'code' },
//     { text: 'print(response.msgs[0].content)', type: 'code' },
//   ];

//   // Typing animation effect
//   useEffect(() => {
//     if (currentLineIndex >= codeLines.length) {
//       // Reset after completion
//       setTimeout(() => {
//         setDisplayedLines([]);
//         setCurrentLineIndex(0);
//         setCurrentCharIndex(0);
//       }, 3000);
//       return;
//     }

//     const currentLine = codeLines[currentLineIndex];
    
//     if (currentCharIndex <= currentLine.text.length) {
//       const timer = setTimeout(() => {
//         setDisplayedLines(prev => {
//           const newLines = [...prev];
//           newLines[currentLineIndex] = {
//             ...currentLine,
//             text: currentLine.text.slice(0, currentCharIndex)
//           };
//           return newLines;
//         });
//         setCurrentCharIndex(prev => prev + 1);
//       }, 30); // Typing speed
      
//       return () => clearTimeout(timer);
//     } else {
//       // Move to next line
//       setTimeout(() => {
//         setCurrentLineIndex(prev => prev + 1);
//         setCurrentCharIndex(0);
//       }, 100);
//     }
//   }, [currentLineIndex, currentCharIndex, codeLines.length]);

//   const getLineColor = (type) => {
//     switch (type) {
//       case 'import': return '#c792ea';
//       case 'comment': return '#546e7a';
//       case 'string': return '#c3e88d';
//       case 'param': return '#89ddff';
//       case 'code': return '#82aaff';
//       default: return '#eeffff';
//     }
//   };

//   return (
//     <div className="macbook-container">
//       {/* MacBook Pro */}
//       <div className="macbook">
//         {/* Screen Lid */}
//         <div className="screen-lid">
//           {/* Camera Notch */}
//           <div className="notch">
//             <div className="camera"></div>
//           </div>
          
//           {/* Screen */}
//           <div className="screen">
//             {/* Menu Bar */}
//             <div className="menu-bar">
//               <div className="menu-left">
//                 <span className="apple-logo">&#63743;</span>
//                 <span>File</span>
//                 <span>Edit</span>
//                 <span>View</span>
//                 <span>Terminal</span>
//               </div>
//               <div className="menu-right">
//                 <span>100%</span>
//                 <span>Tue 10:30 PM</span>
//               </div>
//             </div>

//             {/* Terminal Window */}
//             <div className="terminal-window">
//               {/* Window Header */}
//               <div className="window-header">
//                 <div className="window-buttons">
//                   <span className="btn red"></span>
//                   <span className="btn yellow"></span>
//                   <span className="btn green"></span>
//                 </div>
//                 <div className="window-title">
//                   <span className="folder-icon">📁</span>
//                   camel-ai — python3
//                 </div>
//                 <div className="window-actions"></div>
//               </div>

//               {/* Code Area */}
//               <div className="code-area">
//                 <div className="line-numbers">
//                   {displayedLines.map((_, i) => (
//                     <span key={i}>{i + 1}</span>
//                   ))}
//                   {currentLineIndex < codeLines.length && (
//                     <span>{displayedLines.length + 1}</span>
//                   )}
//                 </div>
                
//                 <div className="code-content">
//                   {displayedLines.map((line, i) => (
//                     <div key={i} className="code-line">
//                       <span style={{ color: getLineColor(line.type) }}>
//                         {line.text}
//                       </span>
//                       {i === currentLineIndex && currentCharIndex <= codeLines[currentLineIndex]?.text.length && (
//                         <span className="cursor">|</span>
//                       )}
//                     </div>
//                   ))}
//                   {currentLineIndex < codeLines.length && displayedLines.length === currentLineIndex && (
//                     <div className="code-line">
//                       <span className="cursor">|</span>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Dock */}
//             <div className="dock">
//               <div className="dock-item">🔍</div>
//               <div className="dock-item active">💻</div>
//               <div className="dock-item">📁</div>
//               <div className="dock-item">🌐</div>
//               <div className="dock-item">⚙️</div>
//             </div>
//           </div>
//         </div>

//         {/* Keyboard Base */}
//         <div className="keyboard-base">
//           <div className="keyboard-surface">
//             {/* Keyboard Keys */}
//             <div className="keyboard-rows">
//               {[...Array(4)].map((_, row) => (
//                 <div key={row} className="key-row">
//                   {[...Array(row === 3 ? 10 : 12)].map((_, key) => (
//                     <div 
//                       key={key} 
//                       className={`key ${row === 3 && key === 4 ? 'spacebar' : ''}`}
//                     ></div>
//                   ))}
//                 </div>
//               ))}
//             </div>
            
//             {/* Trackpad */}
//             <div className="trackpad"></div>
//           </div>
//         </div>

//         {/* Bottom Edge */}
//         <div className="bottom-edge"></div>
//       </div>

//       {/* Reflection */}
//       <div className="reflection"></div>

//       <style jsx>{`
//         .macbook-container {
//           position: relative;
//           width: 100%;
//           height: 100%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           perspective: 1500px;
//         }

//         .macbook {
//           position: relative;
//           transform-style: preserve-3d;
//           transform: rotateX(5deg) rotateY(-5deg);
//           animation: macFloat 6s ease-in-out infinite;
//         }

//         /* Screen Lid */
//         .screen-lid {
//           position: relative;
//           width: 540px;
//           height: 360px;
//           background: linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%);
//           border-radius: 16px 16px 0 0;
//           padding: 8px;
//           box-shadow: 
//             0 -2px 20px rgba(0, 0, 0, 0.5),
//             inset 0 0 0 2px rgba(255, 255, 255, 0.1);
//           transform-origin: bottom center;
//         }

//         /* Notch */
//         .notch {
//           position: absolute;
//           top: 8px;
//           left: 50%;
//           transform: translateX(-50%);
//           width: 120px;
//           height: 24px;
//           background: #000;
//           border-radius: 0 0 12px 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 10;
//         }

//         .camera {
//           width: 8px;
//           height: 8px;
//           background: #1a1a2e;
//           border-radius: 50%;
//           box-shadow: inset 0 0 2px rgba(0, 255, 209, 0.5);
//         }

//         /* Screen */
//         .screen {
//           width: 100%;
//           height: 100%;
//           background: linear-gradient(180deg, #1e1e2e 0%, #0d0d14 100%);
//           border-radius: 12px;
//           overflow: hidden;
//           position: relative;
//         }

//         /* Menu Bar */
//         .menu-bar {
//           height: 24px;
//           background: rgba(30, 30, 40, 0.95);
//           backdrop-filter: blur(10px);
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           padding: 0 12px;
//           font-size: 11px;
//           color: rgba(255, 255, 255, 0.8);
//         }

//         .menu-left, .menu-right {
//           display: flex;
//           gap: 12px;
//         }

//         .apple-logo {
//           font-size: 14px;
//         }

//         /* Terminal Window */
//         .terminal-window {
//           position: absolute;
//           top: 35px;
//           left: 12px;
//           right: 12px;
//           bottom: 55px;
//           background: #1e1e2e;
//           border-radius: 8px;
//           overflow: hidden;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
//           border: 1px solid rgba(255, 255, 255, 0.1);
//         }

//         .window-header {
//           height: 32px;
//           background: linear-gradient(180deg, #3d3d4d 0%, #2d2d3d 100%);
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           padding: 0 12px;
//           border-bottom: 1px solid rgba(0, 0, 0, 0.3);
//         }

//         .window-buttons {
//           display: flex;
//           gap: 6px;
//         }

//         .btn {
//           width: 10px;
//           height: 10px;
//           border-radius: 50%;
//         }

//         .btn.red { background: #ff5f57; }
//         .btn.yellow { background: #febc2e; }
//         .btn.green { background: #28c840; }

//         .window-title {
//           font-size: 11px;
//           color: rgba(255, 255, 255, 0.7);
//           display: flex;
//           align-items: center;
//           gap: 6px;
//         }

//         .folder-icon {
//           font-size: 12px;
//         }

//         /* Code Area */
//         .code-area {
//           display: flex;
//           height: calc(100% - 32px);
//           font-family: 'JetBrains Mono', 'Fira Code', monospace;
//           font-size: 11px;
//           line-height: 1.6;
//         }

//         .line-numbers {
//           width: 35px;
//           padding: 12px 8px;
//           background: rgba(0, 0, 0, 0.2);
//           color: rgba(255, 255, 255, 0.3);
//           text-align: right;
//           display: flex;
//           flex-direction: column;
//           border-right: 1px solid rgba(255, 255, 255, 0.05);
//         }

//         .code-content {
//           flex: 1;
//           padding: 12px;
//           overflow: hidden;
//         }

//         .code-line {
//           white-space: pre;
//           min-height: 17.6px;
//         }

//         .cursor {
//           color: #00ffd1;
//           animation: blink 1s step-end infinite;
//           font-weight: bold;
//           text-shadow: 0 0 10px #00ffd1;
//         }

//         /* Dock */
//         .dock {
//           position: absolute;
//           bottom: 8px;
//           left: 50%;
//           transform: translateX(-50%);
//           display: flex;
//           gap: 4px;
//           padding: 4px 8px;
//           background: rgba(255, 255, 255, 0.1);
//           backdrop-filter: blur(10px);
//           border-radius: 12px;
//           border: 1px solid rgba(255, 255, 255, 0.1);
//         }

//         .dock-item {
//           width: 32px;
//           height: 32px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 18px;
//           border-radius: 8px;
//           transition: transform 0.2s;
//         }

//         .dock-item.active {
//           background: rgba(0, 255, 209, 0.2);
//         }

//         /* Keyboard Base */
//         .keyboard-base {
//           width: 540px;
//           height: 20px;
//           background: linear-gradient(180deg, #3d3d3d 0%, #2a2a2a 50%, #1a1a1a 100%);
//           border-radius: 0 0 12px 12px;
//           transform: rotateX(-80deg) translateY(-8px) translateZ(10px);
//           transform-origin: top center;
//           position: relative;
//         }

//         .keyboard-surface {
//           position: absolute;
//           top: -140px;
//           left: 0;
//           width: 100%;
//           height: 140px;
//           background: linear-gradient(180deg, #2a2a2a 0%, #1f1f1f 100%);
//           border-radius: 0 0 12px 12px;
//           padding: 15px 25px;
//           box-shadow: 
//             inset 0 2px 10px rgba(0, 0, 0, 0.5),
//             0 0 30px rgba(0, 255, 209, 0.1);
//         }

//         .keyboard-rows {
//           display: flex;
//           flex-direction: column;
//           gap: 4px;
//         }

//         .key-row {
//           display: flex;
//           justify-content: center;
//           gap: 3px;
//         }

//         .key {
//           width: 32px;
//           height: 18px;
//           background: linear-gradient(180deg, #3a3a3a 0%, #2a2a2a 100%);
//           border-radius: 3px;
//           box-shadow: 
//             0 1px 0 rgba(0, 0, 0, 0.5),
//             inset 0 1px 0 rgba(255, 255, 255, 0.05);
//         }

//         .key.spacebar {
//           width: 140px;
//         }

//         .trackpad {
//           width: 200px;
//           height: 30px;
//           background: linear-gradient(180deg, #333 0%, #2a2a2a 100%);
//           border-radius: 6px;
//           margin: 8px auto 0;
//           box-shadow: 
//             inset 0 0 10px rgba(0, 0, 0, 0.3),
//             0 1px 2px rgba(0, 0, 0, 0.3);
//         }

//         .bottom-edge {
//           width: 540px;
//           height: 8px;
//           background: linear-gradient(180deg, #1a1a1a 0%, #0d0d0d 100%);
//           border-radius: 0 0 4px 4px;
//           transform: translateY(130px) translateZ(10px);
//           box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
//         }

//         /* Reflection */
//         .reflection {
//           position: absolute;
//           bottom: -80px;
//           left: 50%;
//           transform: translateX(-50%);
//           width: 400px;
//           height: 60px;
//           background: linear-gradient(180deg, rgba(0, 255, 209, 0.1) 0%, transparent 100%);
//           filter: blur(20px);
//           border-radius: 50%;
//         }

//         @keyframes macFloat {
//           0%, 100% {
//             transform: rotateX(5deg) rotateY(-5deg) translateY(0);
//           }
//           50% {
//             transform: rotateX(8deg) rotateY(-3deg) translateY(-15px);
//           }
//         }

//         @keyframes blink {
//           0%, 50% { opacity: 1; }
//           51%, 100% { opacity: 0; }
//         }

//         /* Responsive */
//         @media (max-width: 768px) {
//           .macbook {
//             transform: scale(0.6) rotateX(5deg) rotateY(-5deg);
//           }
//         }

//         @media (max-width: 480px) {
//           .macbook {
//             transform: scale(0.4) rotateX(5deg) rotateY(-5deg);
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default CodeLaptop3D;






































import React, { useState, useEffect } from 'react';

const CodeLaptop3D = () => {
  const [displayedLines, setDisplayedLines] = useState([]);
  const [currentLineIndex, setCurrentLineIndex] = useState(0);
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const codeLines = [
    { text: 'from camel.agents import ChatAgent', type: 'import' },
    { text: 'from camel.models import ModelFactory', type: 'import' },
    { text: 'from camel.types import ModelPlatformType', type: 'import' },
    { text: '', type: 'empty' },
    { text: '# Initialize AI Agent', type: 'comment' },
    { text: 'agent = ChatAgent(', type: 'code' },
    { text: '    "You are a helpful assistant.",', type: 'string' },
    { text: '    model="gpt-4o-mini"', type: 'param' },
    { text: ')', type: 'code' },
    { text: '', type: 'empty' },
    { text: '# Using ModelFactory', type: 'comment' },
    { text: 'model = ModelFactory.create(', type: 'code' },
    { text: '    model_platform=ModelPlatformType.OPENAI,', type: 'param' },
    { text: ')', type: 'code' },
    { text: '', type: 'empty' },
    { text: 'response = agent.step("Hello!")', type: 'code' },
    { text: 'print(response.msgs[0].content)', type: 'code' },
  ];

  // Typing animation
  useEffect(() => {
    if (currentLineIndex >= codeLines.length) {
      setTimeout(() => {
        setDisplayedLines([]);
        setCurrentLineIndex(0);
        setCurrentCharIndex(0);
      }, 3000);
      return;
    }

    const currentLine = codeLines[currentLineIndex];
    
    if (currentCharIndex <= currentLine.text.length) {
      const timer = setTimeout(() => {
        setDisplayedLines(prev => {
          const newLines = [...prev];
          newLines[currentLineIndex] = {
            ...currentLine,
            text: currentLine.text.slice(0, currentCharIndex)
          };
          return newLines;
        });
        setCurrentCharIndex(prev => prev + 1);
      }, 25);
      
      return () => clearTimeout(timer);
    } else {
      setTimeout(() => {
        setCurrentLineIndex(prev => prev + 1);
        setCurrentCharIndex(0);
      }, 80);
    }
  }, [currentLineIndex, currentCharIndex]);

  const getLineColor = (type) => {
    switch (type) {
      case 'import': return '#c792ea';
      case 'comment': return '#546e7a';
      case 'string': return '#c3e88d';
      case 'param': return '#89ddff';
      case 'code': return '#82aaff';
      default: return '#eeffff';
    }
  };

  // Mobile Phone View
  if (isMobile) {
    return (
      <div className="phone-container">
        <div className="phone-frame">
          {/* Phone Notch */}
          <div className="phone-notch">
            <div className="phone-speaker"></div>
            <div className="phone-camera"></div>
          </div>
          
          {/* Phone Screen */}
          <div className="phone-screen">
            {/* Status Bar */}
            <div className="status-bar">
              <span>9:41</span>
              <div className="status-icons">
                <span>📶</span>
                <span>🔋</span>
              </div>
            </div>

            {/* Code Editor */}
            <div className="mobile-editor">
              <div className="editor-header">
                <div className="editor-dots">
                  <span className="dot red"></span>
                  <span className="dot yellow"></span>
                  <span className="dot green"></span>
                </div>
                <span className="editor-title">camel_ai.py</span>
              </div>
              
              <div className="editor-content">
                {displayedLines.map((line, i) => (
                  <div key={i} className="mobile-code-line">
                    <span className="line-num">{i + 1}</span>
                    <span style={{ color: getLineColor(line.type) }}>
                      {line.text}
                    </span>
                    {i === currentLineIndex && (
                      <span className="mobile-cursor">|</span>
                    )}
                  </div>
                ))}
                {currentLineIndex < codeLines.length && 
                 displayedLines.length === currentLineIndex && (
                  <div className="mobile-code-line">
                    <span className="line-num">{displayedLines.length + 1}</span>
                    <span className="mobile-cursor">|</span>
                  </div>
                )}
              </div>
            </div>

            {/* Bottom Nav */}
            <div className="bottom-nav">
              <div className="nav-item active">🏠</div>
              <div className="nav-item">📝</div>
              <div className="nav-item">⚙️</div>
            </div>
          </div>

          {/* Home Indicator */}
          <div className="home-indicator"></div>
        </div>

        {/* Phone Reflection */}
        <div className="phone-reflection"></div>

        <style jsx>{`
          .phone-container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 20px;
            perspective: 1000px;
          }

          .phone-frame {
            position: relative;
            width: 280px;
            max-width: 90vw;
            height: 560px;
            max-height: 80vh;
            background: linear-gradient(145deg, #2a2a2a 0%, #1a1a1a 100%);
            border-radius: 40px;
            padding: 12px;
            box-shadow: 
              0 25px 50px rgba(0, 0, 0, 0.5),
              0 0 0 1px rgba(255, 255, 255, 0.1),
              inset 0 0 0 1px rgba(255, 255, 255, 0.05);
            animation: phoneFloat 6s ease-in-out infinite;
            transform: rotateY(-5deg) rotateX(5deg);
          }

          .phone-notch {
            position: absolute;
            top: 12px;
            left: 50%;
            transform: translateX(-50%);
            width: 120px;
            height: 28px;
            background: #000;
            border-radius: 0 0 16px 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            z-index: 10;
          }

          .phone-speaker {
            width: 50px;
            height: 4px;
            background: #333;
            border-radius: 2px;
          }

          .phone-camera {
            width: 10px;
            height: 10px;
            background: #1a1a2e;
            border-radius: 50%;
            box-shadow: 0 0 5px rgba(0, 255, 209, 0.3);
          }

          .phone-screen {
            width: 100%;
            height: 100%;
            background: linear-gradient(180deg, #0a0a0f 0%, #1a1a2e 100%);
            border-radius: 32px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
          }

          .status-bar {
            height: 44px;
            padding: 12px 24px 0;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            font-size: 14px;
            font-weight: 600;
            color: white;
          }

          .status-icons {
            display: flex;
            gap: 4px;
            font-size: 12px;
          }

          .mobile-editor {
            flex: 1;
            margin: 8px;
            background: #1e1e2e;
            border-radius: 16px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
          }

          .editor-header {
            height: 36px;
            background: linear-gradient(180deg, #3d3d4d 0%, #2d2d3d 100%);
            display: flex;
            align-items: center;
            padding: 0 12px;
            gap: 8px;
          }

          .editor-dots {
            display: flex;
            gap: 5px;
          }

          .dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
          }

          .dot.red { background: #ff5f57; }
          .dot.yellow { background: #febc2e; }
          .dot.green { background: #28c840; }

          .editor-title {
            flex: 1;
            text-align: center;
            font-size: 11px;
            color: rgba(255, 255, 255, 0.6);
            margin-right: 30px;
          }

          .editor-content {
            flex: 1;
            padding: 12px 8px;
            overflow-y: auto;
            font-family: 'SF Mono', 'Fira Code', monospace;
            font-size: 10px;
            line-height: 1.5;
          }

          .mobile-code-line {
            display: flex;
            white-space: nowrap;
            overflow: hidden;
            min-height: 15px;
          }

          .line-num {
            width: 24px;
            color: rgba(255, 255, 255, 0.2);
            text-align: right;
            margin-right: 8px;
            flex-shrink: 0;
          }

          .mobile-cursor {
            color: #00ffd1;
            animation: blink 1s step-end infinite;
            text-shadow: 0 0 8px #00ffd1;
          }

          .bottom-nav {
            height: 60px;
            background: rgba(30, 30, 40, 0.95);
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 0 20px;
            border-top: 1px solid rgba(255, 255, 255, 0.05);
          }

          .nav-item {
            width: 44px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            border-radius: 12px;
          }

          .nav-item.active {
            background: rgba(0, 255, 209, 0.15);
          }

          .home-indicator {
            position: absolute;
            bottom: 8px;
            left: 50%;
            transform: translateX(-50%);
            width: 120px;
            height: 4px;
            background: rgba(255, 255, 255, 0.3);
            border-radius: 2px;
          }

          .phone-reflection {
            width: 200px;
            height: 40px;
            background: linear-gradient(180deg, rgba(0, 255, 209, 0.15) 0%, transparent 100%);
            filter: blur(20px);
            border-radius: 50%;
            margin-top: 20px;
          }

          @keyframes phoneFloat {
            0%, 100% {
              transform: rotateY(-5deg) rotateX(5deg) translateY(0);
            }
            50% {
              transform: rotateY(-3deg) rotateX(8deg) translateY(-10px);
            }
          }

          @keyframes blink {
            0%, 50% { opacity: 1; }
            51%, 100% { opacity: 0; }
          }
        `}</style>
      </div>
    );
  }

  // Desktop Laptop View
  return (
    <div className="macbook-container">
      <div className="macbook">
        {/* Screen */}
        <div className="screen-lid">
          <div className="notch">
            <div className="camera"></div>
          </div>
          
          <div className="screen">
            {/* Menu Bar */}
            <div className="menu-bar">
              <div className="menu-left">
                <span className="apple-logo"></span>
                <span>File</span>
                <span>Edit</span>
                <span>View</span>
              </div>
              <div className="menu-right">
                <span>100%</span>
                <span>10:30 PM</span>
              </div>
            </div>

            {/* Terminal */}
            <div className="terminal-window">
              <div className="window-header">
                <div className="window-buttons">
                  <span className="btn red"></span>
                  <span className="btn yellow"></span>
                  <span className="btn green"></span>
                </div>
                <div className="window-title">📁 camel-ai — python3</div>
                <div></div>
              </div>

              <div className="code-area">
                <div className="line-numbers">
                  {displayedLines.map((_, i) => (
                    <span key={i}>{i + 1}</span>
                  ))}
                  {currentLineIndex < codeLines.length && (
                    <span>{displayedLines.length + 1}</span>
                  )}
                </div>
                
                <div className="code-content">
                  {displayedLines.map((line, i) => (
                    <div key={i} className="code-line">
                      <span style={{ color: getLineColor(line.type) }}>
                        {line.text}
                      </span>
                      {i === currentLineIndex && (
                        <span className="cursor">|</span>
                      )}
                    </div>
                  ))}
                  {currentLineIndex < codeLines.length && 
                   displayedLines.length === currentLineIndex && (
                    <div className="code-line">
                      <span className="cursor">|</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Dock */}
            <div className="dock">
              <div className="dock-item">🔍</div>
              <div className="dock-item active">💻</div>
              <div className="dock-item">📁</div>
              <div className="dock-item">🌐</div>
            </div>
          </div>
        </div>

        {/* Keyboard */}
        <div className="keyboard-base">
          <div className="keyboard-surface">
            <div className="keyboard-rows">
              {[...Array(3)].map((_, row) => (
                <div key={row} className="key-row">
                  {[...Array(10)].map((_, key) => (
                    <div 
                      key={key} 
                      className={`key ${row === 2 && key === 4 ? 'spacebar' : ''}`}
                    ></div>
                  ))}
                </div>
              ))}
            </div>
            <div className="trackpad"></div>
          </div>
        </div>
      </div>

      <div className="reflection"></div>

      <style jsx>{`
        .macbook-container {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          perspective: 1500px;
          padding: 20px;
        }

        .macbook {
          transform-style: preserve-3d;
          transform: rotateX(5deg) rotateY(-5deg);
          animation: macFloat 6s ease-in-out infinite;
        }

        .screen-lid {
          position: relative;
          width: min(540px, 85vw);
          height: min(360px, 55vw);
          background: linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%);
          border-radius: 16px 16px 0 0;
          padding: 8px;
          box-shadow: 
            0 -2px 20px rgba(0, 0, 0, 0.5),
            inset 0 0 0 2px rgba(255, 255, 255, 0.1);
        }

        .notch {
          position: absolute;
          top: 8px;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 20px;
          background: #000;
          border-radius: 0 0 10px 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
        }

        .camera {
          width: 6px;
          height: 6px;
          background: #1a1a2e;
          border-radius: 50%;
          box-shadow: inset 0 0 2px rgba(0, 255, 209, 0.5);
        }

        .screen {
          width: 100%;
          height: 100%;
          background: linear-gradient(180deg, #1e1e2e 0%, #0d0d14 100%);
          border-radius: 12px;
          overflow: hidden;
        }

        .menu-bar {
          height: 22px;
          background: rgba(30, 30, 40, 0.95);
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          font-size: 10px;
          color: rgba(255, 255, 255, 0.8);
        }

        .menu-left, .menu-right {
          display: flex;
          gap: 10px;
        }

        .terminal-window {
          position: absolute;
          top: 32px;
          left: 10px;
          right: 10px;
          bottom: 48px;
          background: #1e1e2e;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
        }

        .window-header {
          height: 28px;
          background: linear-gradient(180deg, #3d3d4d 0%, #2d2d3d 100%);
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 10px;
        }

        .window-buttons {
          display: flex;
          gap: 5px;
        }

        .btn {
          width: 9px;
          height: 9px;
          border-radius: 50%;
        }

        .btn.red { background: #ff5f57; }
        .btn.yellow { background: #febc2e; }
        .btn.green { background: #28c840; }

        .window-title {
          font-size: 10px;
          color: rgba(255, 255, 255, 0.7);
        }

        .code-area {
          display: flex;
          height: calc(100% - 28px);
          font-family: 'JetBrains Mono', monospace;
          font-size: min(11px, 2.5vw);
          line-height: 1.5;
        }

        .line-numbers {
          width: 30px;
          padding: 10px 6px;
          background: rgba(0, 0, 0, 0.2);
          color: rgba(255, 255, 255, 0.3);
          text-align: right;
          display: flex;
          flex-direction: column;
        }

        .code-content {
          flex: 1;
          padding: 10px;
          overflow: hidden;
        }

        .code-line {
          white-space: pre;
          min-height: 16px;
        }

        .cursor {
          color: #00ffd1;
          animation: blink 1s step-end infinite;
          text-shadow: 0 0 10px #00ffd1;
        }

        .dock {
          position: absolute;
          bottom: 6px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 4px;
          padding: 4px 8px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
        }

        .dock-item {
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          border-radius: 6px;
        }

        .dock-item.active {
          background: rgba(0, 255, 209, 0.2);
        }

        .keyboard-base {
          width: min(540px, 85vw);
          height: 16px;
          background: linear-gradient(180deg, #3d3d3d 0%, #1a1a1a 100%);
          border-radius: 0 0 10px 10px;
          transform: rotateX(-80deg) translateY(-6px) translateZ(8px);
          transform-origin: top center;
        }

        .keyboard-surface {
          position: absolute;
          top: -100px;
          left: 0;
          width: 100%;
          height: 100px;
          background: linear-gradient(180deg, #2a2a2a 0%, #1f1f1f 100%);
          border-radius: 0 0 10px 10px;
          padding: 12px 20px;
        }

        .keyboard-rows {
          display: flex;
          flex-direction: column;
          gap: 3px;
        }

        .key-row {
          display: flex;
          justify-content: center;
          gap: 2px;
        }

        .key {
          width: 28px;
          height: 14px;
          background: linear-gradient(180deg, #3a3a3a 0%, #2a2a2a 100%);
          border-radius: 2px;
        }

        .key.spacebar {
          width: 100px;
        }

        .trackpad {
          width: 150px;
          height: 25px;
          background: #2a2a2a;
          border-radius: 5px;
          margin: 6px auto 0;
        }

        .reflection {
          position: absolute;
          bottom: -60px;
          left: 50%;
          transform: translateX(-50%);
          width: 300px;
          height: 50px;
          background: linear-gradient(180deg, rgba(0, 255, 209, 0.1) 0%, transparent 100%);
          filter: blur(15px);
          border-radius: 50%;
        }

        @keyframes macFloat {
          0%, 100% {
            transform: rotateX(5deg) rotateY(-5deg) translateY(0);
          }
          50% {
            transform: rotateX(8deg) rotateY(-3deg) translateY(-12px);
          }
        }

        @keyframes blink {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default CodeLaptop3D;